import { render } from "./SingleVideo.vue?vue&type=template&id=7c43fe26&scoped=true&bindings={\"video\":\"options\",\"trans\":\"options\",\"store\":\"setup\"}"
import script from "./SingleVideo.vue?vue&type=script&lang=js"
export * from "./SingleVideo.vue?vue&type=script&lang=js"

import "./SingleVideo.vue?vue&type=style&index=0&id=7c43fe26&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7c43fe26"

export default script